// extracted by mini-css-extract-plugin
export default {"otpInputContainer":"WCegQHe9t8VkWQC8Cmbt","formButton":"tPGJcI3fW3yQAXpMb2nQ","buttonContainer":"fkJ5KYjN1B8c2NBlJHvU"};